module.exports = __webpack_public_path__ + "static/media/img_section03_finding02.9592d94a.png";